import React from 'react';
import { Button, Stack } from '@mui/material';
import { AddCircle, FileCopy } from '@mui/icons-material';
import { initialConfigRow } from '../../../constants';
import { ProductConfigListingContext } from '../../../types';

interface Props {
  context: ProductConfigListingContext;
}
export const BottomActionPanel = ({ context }: Props) => {
  return (
    <Stack direction="row" gap="0.5rem">
      <Button
        startIcon={<AddCircle />}
        size="small"
        onClick={() => context.handleAddRow(initialConfigRow)}
        disabled={context.isReadOnly}
      >
        Add new Configuration
      </Button>
      <Button
        onClick={context.handleCopyLastConfig}
        startIcon={<FileCopy />}
        size="small"
        disabled={context.isReadOnly}
      >
        Copy last Configuration
      </Button>
    </Stack>
  );
};
